import React from 'react';
import CameraViewIcon from './CameraViewIcon';

export const IconInRoom = () => (
  <CameraViewIcon width="50" height="49.917" viewBox="0 0 602.253 601">
    <g transform="translate(-99 701) scale(0.1 -0.1)" fill="currentColor" stroke="none">
      <path
        d="M1010 6990 c-20 -20 -20 -33 -20 -2986 0 -2025 3 -2971 10 -2985 11
-19 55 -19 3000 -19 2313 0 2990 3 2996 12 4 7 10 1349 12 2984 l5 2971 -22
22 -21 21 -2970 0 c-2957 0 -2970 0 -2990 -20z m5795 -130 l-59 -60 -2746 0
-2746 0 -59 60 -59 60 2864 0 2864 0 -59 -60z m-5663 -57 l58 -57 0 -2745 0
-2745 -57 -58 c-32 -32 -60 -58 -63 -58 -3 0 -5 1287 -5 2860 0 1573 2 2860 5
2860 2 0 30 -26 62 -57z m5783 -2803 c0 -1573 -3 -2860 -6 -2860 -3 0 -31 27
-62 59 l-57 60 0 2742 0 2743 57 58 c32 32 60 58 63 58 3 0 5 -1287 5 -2860z
m-275 2713 c0 -4 -42 -49 -92 -100 l-93 -93 -2465 0 -2465 0 -92 92 c-51 51
-93 96 -93 100 0 5 1193 8 2650 8 1458 0 2650 -3 2650 -7z m-5170 -2713 l0
-2465 -100 -100 -100 -100 0 2665 0 2665 100 -100 100 -100 0 -2465z m5240 -1
c0 -1458 -3 -2649 -8 -2647 -4 2 -49 46 -100 99 l-92 96 0 2459 0 2459 92 92
c51 51 96 93 100 93 5 0 8 -1193 8 -2651z m-2222 1879 l2 -558 -34 0 c-54 0
-66 -26 -66 -141 l0 -96 -232 -131 c-128 -73 -383 -218 -567 -325 -282 -162
-336 -197 -344 -221 -8 -25 -6 -31 17 -50 26 -20 27 -24 24 -111 l-3 -90 -370
-211 c-203 -116 -372 -210 -375 -209 -3 1 -105 59 -226 129 -122 69 -226 126
-231 126 -6 0 -22 -9 -37 -21 l-26 -20 0 -490 0 -489 44 -28 c24 -15 51 -31
60 -37 13 -8 -42 -43 -264 -170 -154 -88 -287 -161 -295 -163 -13 -3 -15 230
-15 1926 0 1061 3 1932 7 1935 3 4 664 6 1467 5 l1461 -3 3 -557z m1939 -1010
c1 -863 0 -1568 -3 -1568 -2 0 -68 37 -147 83 -78 46 -211 123 -294 171 l-153
88 0 431 c-1 327 -4 437 -13 455 -7 12 -55 47 -107 78 -88 53 -918 531 -1075
620 l-70 40 -3 587 -2 587 932 -2 933 -3 2 -1567z m-1671 231 c516 -296 937
-541 979 -568 l40 -27 3 -442 c1 -301 -1 -442 -8 -442 -7 0 -8 135 -4 433 7
399 6 433 -10 446 -10 9 -20 11 -26 5 -5 -5 -11 -125 -12 -269 l-3 -260 -545
-311 c-453 -259 -547 -310 -562 -301 -10 7 -14 15 -10 18 4 4 237 139 517 299
281 161 515 295 520 299 6 3 21 6 35 6 l25 0 3 260 c1 143 0 270 -3 283 -6 26
-30 29 -43 6 -8 -14 -86 28 -508 271 -274 158 -529 305 -566 326 -58 34 -67
43 -70 72 -2 24 -8 32 -23 32 -19 0 -20 -8 -23 -107 -2 -73 -6 -108 -14 -108
-14 0 -93 -45 -651 -367 -241 -140 -452 -256 -468 -260 -39 -7 -37 9 4 29 17
9 260 146 539 306 279 160 520 292 535 294 l28 3 3 123 c1 67 6 122 11 122 5
0 143 -77 307 -171z m341 -326 c276 -158 513 -297 528 -308 26 -20 26 -21 23
-141 l-3 -121 -550 318 c-302 176 -558 319 -567 319 -16 0 -18 13 -18 135 l0
136 43 -25 c23 -13 268 -154 544 -313z m-639 120 c-2 -42 -7 -78 -13 -80 -6
-2 -9 27 -7 77 2 44 8 80 13 80 6 0 9 -32 7 -77z m-115 -133 c-4 -4 -215 -125
-468 -269 l-460 -261 -3 67 c-2 36 1 69 5 74 7 6 578 337 848 491 l80 46 3
-71 c2 -38 -1 -73 -5 -77z m698 -266 c283 -163 520 -302 528 -309 11 -11 -170
-117 -1040 -614 l-1054 -601 -5 109 c-3 67 -10 114 -18 124 -7 8 -52 38 -100
65 -494 283 -738 424 -744 430 -4 4 205 128 465 277 957 547 1432 815 1443
815 6 0 242 -133 525 -296z m-1687 -226 c-3 -40 -8 -75 -10 -77 -2 -2 -4 30
-4 72 0 48 4 77 11 77 7 0 8 -24 3 -72z m2256 -191 l0 -53 -57 -33 c-32 -18
-258 -148 -503 -288 -245 -140 -462 -266 -482 -279 -46 -30 -49 -56 -8 -86
l30 -22 0 -192 c0 -156 3 -194 15 -204 17 -14 27 -9 450 233 267 153 270 154
302 141 74 -31 206 -2 218 48 3 13 5 43 3 67 l-3 43 109 63 110 62 180 -105
c100 -57 241 -139 313 -181 130 -75 133 -77 138 -116 3 -22 5 -392 3 -822 l-3
-783 -2438 0 -2437 0 2 452 3 452 328 190 329 189 64 -34 c100 -53 94 -45 79
-120 -28 -126 -19 -151 58 -184 92 -38 197 -5 207 67 l5 37 270 -155 271 -154
-9 -86 c-7 -60 -6 -93 2 -110 17 -39 72 -57 164 -52 73 3 81 6 104 32 21 25
24 37 20 74 -3 27 0 54 9 71 8 14 14 35 14 46 0 16 114 85 553 335 l552 315 3
176 c3 207 0 214 -70 178 -45 -23 -976 -550 -1016 -576 l-23 -14 3 106 3 105
1065 609 c586 335 1066 609 1068 610 1 1 2 -23 2 -52z m-3416 -204 c78 -43
1105 -632 1113 -637 1 -1 -2 -16 -5 -33 l-7 -32 -575 329 c-523 300 -575 333
-578 358 -5 34 -19 52 -38 45 -12 -4 -14 -75 -14 -459 0 -296 -3 -454 -10
-454 -7 0 -10 163 -10 470 0 356 3 470 12 470 6 0 57 -26 112 -57z m3512 -279
c-5 -12 -1036 -604 -1052 -604 -5 0 -9 71 -9 157 l0 157 530 302 530 303 3
-152 c1 -83 0 -156 -2 -163z m-3414 95 l90 -52 -39 -22 c-41 -24 -44 -23 -115
22 -34 21 -38 28 -38 63 0 22 3 40 6 40 4 0 47 -23 96 -51z m396 -376 c295
-168 554 -317 575 -330 l37 -23 0 -331 c0 -299 -2 -331 -16 -325 -9 3 -255
143 -547 310 -293 167 -547 311 -564 320 l-33 17 0 334 c0 184 3 335 6 335 3
0 247 -138 542 -307z m182 43 l425 -244 3 -42 c3 -37 1 -42 -14 -36 -14 5
-624 353 -858 488 l-68 40 28 19 c16 10 36 19 44 19 9 0 207 -110 440 -244z
m2647 -4 c-17 -16 -127 -30 -127 -16 0 5 28 25 63 46 l62 36 9 -25 c6 -18 4
-29 -7 -41z m-989 -249 l-3 -137 -235 -134 c-129 -74 -367 -210 -528 -302
l-293 -168 3 141 3 141 520 297 c286 163 524 297 528 298 4 1 6 -61 5 -136z
m-1134 84 c16 -12 18 -46 22 -464 4 -484 4 -484 -46 -468 -20 6 -20 11 -20
476 0 495 -1 489 44 456z m-899 -492 c58 -33 63 -38 68 -78 8 -56 -10 -70 -81
-64 -36 2 -60 10 -73 24 -19 18 -19 24 -8 86 7 37 17 67 22 67 5 0 37 -16 72
-35z m754 -429 c15 -8 33 -22 41 -31 7 -8 32 -20 56 -26 31 -8 44 -17 48 -34
14 -53 -17 -71 -110 -63 -77 7 -86 19 -78 101 4 37 9 67 11 67 2 0 16 -6 32
-14z m3298 -878 c51 -51 93 -96 93 -99 0 -4 -1192 -6 -2650 -5 -1457 0 -2650
3 -2650 6 0 2 42 46 92 97 l93 93 2465 0 2465 0 92 -92z m248 -248 l59 -60
-2864 0 -2864 0 59 60 59 60 2746 0 2746 0 59 -60z"
        fill="currentColor"
      />
    </g>
  </CameraViewIcon>
);

export default IconInRoom;
